@let licenseStatusIndicator = licenseStatusIndicator$ | async;

<oly-frame
  #frame
  [showRibbon]="true"
  [ribbonIsCollapsible]="true"
  [ngClass]="{'default__frame--hidden': layoutManagerIsActive}"
  class="default__frame"
  (layoutChange)="handlerLayoutChange()"
>
  <evi-desktop-header
    slot="header"
    [userAvatarUrl]="avatarUrl"
    [userInitials]="initials"
    [showHeaderLeft]="true"
    [showHeaderRight]="true"
    [licenseStatusButton]="licenseStatusIndicator"
    (statusButtonClicked)="openLicenseModal()"
    (menuTabClicked)="frame.toggleRibbonVisibilityByTab($event)"
  >
    <ng-container slot="header-left">
      <evi-desktop-header-menu-item
        iconSet="solid"
        dataTestId="ribbon-app-tab"
        [label]="appName"
        [iconName]="appIcon"
        [routerLinkValue]="['/', {outlets: {ribbon:'ribbon'}}]"
        [routerLinkActiveExact]="true"
      ></evi-desktop-header-menu-item>

      <evi-desktop-header-menu-item
        label="Ultrasound"
        [routerLinkValue]="['/', {outlets: {ribbon:'ribbon/ut-settings'}}]"
        [disabled]="!isFileLoaded"
      ></evi-desktop-header-menu-item>

      <evi-desktop-header-menu-item
        dataTestId="ribbon-gates-tab"
        label="Gates"
        [routerLinkValue]="['/', {outlets: {ribbon:'ribbon/gates'}}]"
        [disabled]="!isFileLoaded"
      ></evi-desktop-header-menu-item>

      <evi-desktop-header-menu-item
        label="TCG"
        dataTestId="ribbon-tcg-tab"
        [routerLinkValue]="['/', {outlets: {ribbon:'ribbon/tcg'}}]"
        [disabled]="!isFileLoaded"
      ></evi-desktop-header-menu-item>

      @if (featureFlagEncoder) {
        <evi-desktop-header-menu-item
          label="Scanner"
          [routerLinkValue]="['/', {outlets: {ribbon:'ribbon/scanner'}}]"
          [disabled]="!isFileLoaded"
        ></evi-desktop-header-menu-item>
      }

      <evi-desktop-header-menu-item
        label="Inspect"
        [routerLinkValue]="['/', {outlets: {ribbon:'ribbon/inspect'}}]"
        [disabled]="!isFileLoaded"
      ></evi-desktop-header-menu-item>

      @if (canShowAnalysisMenu && featureFlagAnalysis) {
        <evi-desktop-header-menu-item
          label="Analysis"
          [routerLinkValue]="['/', {outlets: {ribbon:'ribbon/analysis'}}]"
          [disabled]="!isFileLoaded"
        ></evi-desktop-header-menu-item>
      }

      @if (featureFlagCScanThickness) {
        <evi-desktop-header-menu-item
          label="Display"
          dataTestId="ribbon-display-tab"
          [routerLinkValue]="['/', {outlets: {ribbon:'ribbon/display'}}]"
          [disabled]="!isFileLoaded"
        ></evi-desktop-header-menu-item>
      }

      @if (featureFlagAnalysis) {
        <evi-desktop-header-menu-item
          label="Report"
          dataTestId="ribbon-report-tab"
          [routerLinkValue]="['/', {outlets: {ribbon:'ribbon/report'}}]"
          [disabled]="!isFileLoaded && !featureFlagTilingCanvas"
        ></evi-desktop-header-menu-item>
      }
    </ng-container>

    <ng-container slot="version">
      @if (showReleaseNotes) {
        <button (click)="showReleaseNotesDialog()">{{ VERSION }}</button>
      } @else {
        <span>{{ VERSION }}</span>
      }
    </ng-container>

    @if (isCloudConnected) {
      <ng-template #appProfileMenu>
        <app-profile-menu></app-profile-menu>
      </ng-template>
    }

    <ng-template #appPreferenceMenu>
      <app-settings-menu></app-settings-menu>
    </ng-template>

    <ng-template #appHelpMenu>
      <app-help-menu></app-help-menu>
    </ng-template>

    @if (isFileLoaded) {
      <ng-template #appViewMenu>
        <app-view-menu></app-view-menu>
      </ng-template>
    }
  </evi-desktop-header>

  <ng-container slot="ribbon-main">
    <div
      class="default__ribbon-main-wrapper"
      [ngStyle]="{
        'margin-left': ribbonPaddingLeft + 'px',
        'width': 'calc(100% - ' + ribbonPaddingLeft + 'px)'
      }"
    >
      <div class="default__ribbon-main-left">
        <router-outlet
          name="ribbon"
          #outlet="outlet"
        ></router-outlet>
      </div>

      @if (canShowZoneHistogram && isFileLoaded && featureFlagAnalysis && !layoutManagerIsActive) {
        <oly-zone-statistics-histogram class="default__ribbon-main-right"></oly-zone-statistics-histogram>
      }
    </div>
  </ng-container>

  <ng-container slot="ribbon-aside">
    <oly-ribbon-view></oly-ribbon-view>
  </ng-container>

  <ng-container slot="toolbar">
    @if (isFileLoaded) {
      <app-toolbar
        [isFileLoaded]="isFileLoaded"
        (quickActionsToggled)="onQuickActionsToggled($event)"
      ></app-toolbar>
    }
  </ng-container>

  <ng-container slot="main">
    @if (showLayout && !layoutManagerIsActive) {
      <div class="default__layouts-wrapper">
        <router-outlet></router-outlet>
        <router-outlet name="table"></router-outlet>
      </div>
    }
  </ng-container>

  <ng-container slot="aside">
    <router-outlet
      name="aside"
      #outletAside="outlet"
    ></router-outlet>
  </ng-container>

  <oly-statusbar slot="footer" />
</oly-frame>

<router-outlet name="modal"></router-outlet>

<ng-container slot="footer">

</ng-container>

<router-outlet name="manager"></router-outlet>
